var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMosaic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.75C2 5.78307 2.8 5 3.78571 5H9.5C10.4867 5 11.2857 5.784 11.2857 6.75V10.25C11.2857 11.2169 10.4857 12 9.5 12H3.78571C3.31211 12 2.85791 11.8156 2.52302 11.4874C2.18814 11.1592 2 10.7141 2 10.25V6.75ZM13.4286 8.15C13.4286 7.18307 14.2286 6.4 15.2143 6.4H20.2143C21.2 6.4 22 7.184 22 8.15V15.85C22 16.816 21.2 17.6 20.2143 17.6H15.2143C14.7407 17.6 14.2865 17.4156 13.9516 17.0874C13.6167 16.7592 13.4286 16.3141 13.4286 15.85V8.15ZM3.42857 15.15C3.42857 14.1831 4.22857 13.4 5.21429 13.4H10.2143C11.201 13.4 12 14.184 12 15.15V17.25C12 18.216 11.2 19 10.2143 19H5.21429C4.74068 19 4.28648 18.8156 3.9516 18.4874C3.61671 18.1592 3.42857 17.7141 3.42857 17.25V15.15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaic);
export default __webpack_public_path__ + "static/media/mosaic.0886679a53500bc3b9703d10ee42663c.svg";
export { ForwardRef as ReactComponent };